import spark from '../images/logos/mitSpark.png'
import ventureLab from '../images/logos/ventureLab.png'
import scaleway from '../images/logos/scaleway.png'
import conceptionX from '../images/logos/conceptionX.png'

// Supported by logos

export const supportedByLogos = [spark, ventureLab, scaleway, conceptionX]
